import { METHODOLOGY, IRMA_FRAMEWORK } from "../../data/config";
import { Reveal } from "../common/Reveal";

const StepList = ({ steps, prefix, testIdPrefix }) => (
  <ol className="mt-10 space-y-0">
    {steps.map((s, i) => (
      <li
        key={s.step}
        className="group flex gap-6 border-b border-navy/10 py-6 last:border-b-0"
        data-testid={`${testIdPrefix}-step-${i + 1}`}
      >
        <span className="font-serif text-2xl text-gold" aria-hidden="true">
          {String(i + 1).padStart(2, "0")}
        </span>
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-navy">
            {s.step}
          </p>
          <p className="mt-2 text-sm leading-relaxed text-ink/70">{s.description}</p>
        </div>
      </li>
    ))}
  </ol>
);

export const HowWeWork = () => (
  <section className="bg-sand py-24 lg:py-32" data-testid="how-we-work-section">
    <div className="container-site">
      <Reveal>
        <p className="eyebrow">How we work</p>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight text-navy sm:text-4xl lg:text-5xl">
          Two frameworks. <span className="italic text-emerald">One discipline.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-16 lg:grid-cols-2">
        <Reveal>
          <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ink/50">
            Growth Methodology
          </p>
          <h3 className="mt-3 font-serif text-2xl text-navy">
            Diagnose → Understand → Intervene → Grow
          </h3>
          <StepList steps={METHODOLOGY} testIdPrefix="methodology" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-ink/50">
            Framework IRMA
          </p>
          <h3 className="mt-3 font-serif text-2xl text-navy">
            Inspire → Reframe → Mobilise → Ascend
          </h3>
          <StepList steps={IRMA_FRAMEWORK} testIdPrefix="irma" />
        </Reveal>
      </div>
    </div>
  </section>
);
